import MessagingClient from './client';
export default MessagingClient;
//# sourceMappingURL=index.js.map